export enum RequestAcceptanceStatus {
  NONE,
  OK,
  KO
}
